import React, { useEffect, useState } from "react";
import DashboardLayout from "../common/DashboardApp";
import Loader from "../common/Loader";
import { getApprovedApplicationData, uploadTask } from "../../../service/api";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";

const ManageTask = () => {
  const [applicationData, setApplicationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnloading, setBtnLoading] = useState(false);
  const [selectedTask, setSelectedTask] = useState({});
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState(null);
  const [inputMode, setInputMode] = useState("hours");

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const data = await getApprovedApplicationData();
        console.log("fetching jobs:", data);
        setApplicationData(data?.data || []);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  const handleOpenModal = (job) => {
    setSelectedTask(job);
    setProgress(0);
    setFile(null);
  };

  const handleProgressChange = (e) => {
    setProgress(Number(e.target.value));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUploadTask = async (e) => {
    e.preventDefault();

    // if (!file) {
    //   toast.error("Please select a file.");
    //   return;
    // }

    // Use FormData directly from the form
    const formData = new FormData(e.target);
    formData.append("jobApplicationId", selectedTask.applicationId);
    formData.append("progressPercent", progress);
    formData.append("file", file);

    console.log("Form Data Entries:", [...formData.entries()]); // Optional debug

    try {
      setBtnLoading(true);
      const response = await uploadTask(formData);
      toast.success(response.data.message || "Task uploaded successfully!");
      setSelectedTask({});
    } catch (error) {
      console.error("Error uploading task:", error);
      toast.error(error.response?.data?.message || "Failed to upload task.");
    } finally {
      setBtnLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <DashboardLayout>
      <div className="panelMainWrapper">
        <div className="titlSectionu userpaneltitle text-left position-relative">
          <h2>Manage Task</h2>
        </div>

        {applicationData.length === 0 ? (
          <div className="alert alert-info text-center">
            No approved applications found.
          </div>
        ) : (
          <table className="table mt-4 hj-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Job Title</th>
                <th>Company</th>
                <th>Total Tasks</th>
                <th>Approved Tasks</th>
                <th>Hours Completed</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {applicationData.map((job, index) => (
                <tr key={job.applicationId}>
                  <td>{index + 1}</td>
                  <td>{job.jobTitle}</td>
                  <td>
                    <div className="d-flex align-items-center gap-3">
                      <img
                        src={"/assets/img/company-profiles/image-1.png"}
                        alt="icon"
                        className="astrologImg"
                        style={{ width: 40, height: 40, borderRadius: "50%" }}
                      />
                          <div className="transactiondinfo">
                            <h5>{job.companyName}</h5>
                            <p>{job.city}, {job.state}</p>
                          </div>
                    </div>
                  </td>
                  <td>{job.totalTask}</td>
                  <td>{job.totalTaskApproved}</td>
                  <td>{job.taskHours}</td>
                  <td>
                    <span
                      style={{
                        backgroundColor:
                          job.employerApprovalStatus === "Approved"
                            ? "#00e721"
                            : job.employerApprovalStatus === "Rejected"
                            ? "#e71b00"
                            : "#e7b100",
                        padding: "2px 12px",
                        borderRadius: "15px",
                        color: "#fff",
                      }}
                    >
                      {job.employerApprovalStatus}
                    </span>
                  </td>
                  <td>
                    <button
                      className="mainbtn"
                      onClick={() => handleOpenModal(job)}
                    >
                      Upload Task
                    </button>
                    <a
                      className="mainbtn"
                      style={{
                        backgroundColor: "#270b79",
                        border: "4px solid #270b79",
                        marginLeft: "4px",
                      }}
                      href={`/jobseeker/task-list/${job.applicationId}`}
                    >
                      Task List
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Modal */}
        {selectedTask.applicationId && (
          <div
            className="modal show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Task</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setSelectedTask({})}
                  ></button>
                </div>
                <div className="modal-body hj-form">
                  <form onSubmit={handleUploadTask}>
                    <div className="mb-2">
                      <label>Title *</label>
                      <input
                        type="text"
                        name="title"
                        className="form-control"
                        placeholder="Task title"
                      />
                    </div>
                    <div className="mb-2">
                      <label>Remarks *</label>
                      <textarea
                        name="description"
                        className="form-control"
                        rows={4}
                        placeholder="Task description"
                      />
                    </div>
                    <div className="work-input-section">
                      {/* Toggle Buttons */}
                      <div className="mb-3">
                        <label className="me-3">Choose Input Method:</label>
                        <div className="btn-group">
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              inputMode === "hours"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => setInputMode("hours")}
                          >
                            Enter Hours
                          </button>
                          <button
                            type="button"
                            className={`btn btn-sm ${
                              inputMode === "time"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => setInputMode("time")}
                          >
                            Enter Start & End Time
                          </button>
                        </div>
                      </div>

                      {/* Hours Worked */}
                      {inputMode === "hours" && (
                        <div className="row mb-2">
                          <div className="col-md-12">
                            <label>Hours Worked *</label>
                            <input
                              type="number"
                              name="hoursWorked"
                              className="form-control"
                              placeholder="Enter total working hours"
                              required={inputMode === "hours"}
                            />
                          </div>
                        </div>
                      )}

                      {/* Start & End Time */}
                      {inputMode === "time" && (
                        <div className="row mb-2">
                          <div className="col-md-6">
                            <label>Start Time *</label>
                            <input
                              type="time"
                              name="startTime"
                              className="form-control"
                              required={inputMode === "time"}
                            />
                          </div>
                          <div className="col-md-6">
                            <label>End Time *</label>
                            <input
                              type="time"
                              name="endTime"
                              className="form-control"
                              required={inputMode === "time"}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label>Progress *</label>
                      <input
                        type="range"
                        min="0"
                        max="100"
                        step="1"
                        value={progress}
                        onChange={handleProgressChange}
                        className="form-range"
                      />
                      <div className="d-flex justify-content-between">
                        <small>0%</small>
                        <span
                          style={{
                            fontWeight: "bold",
                            color:
                              progress < 40
                                ? "red"
                                : progress < 70
                                ? "orange"
                                : "green",
                          }}
                        >
                          {progress}%
                        </span>
                        <small>100%</small>
                      </div>
                    </div>
                    <div className="mb-2">
                      <label>Attach File *</label>
                      <input
                        type="file"
                        className="form-control"
                        onChange={handleFileChange}
                      />
                    </div>
                    <button
                      type="submit"
                      className="w-100 normalbtn"
                      disabled={btnloading}
                    >
                      {btnloading ? (
                        <span>
                          <i
                            className="fa fa-spinner fa-spin"
                            style={{ marginRight: "8px" }}
                          ></i>
                          Uploading...
                        </span>
                      ) : (
                        "Upload Task"
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ManageTask;
